import { Suspense, type ReactNode } from "react";

/** Suspense des routes chargées à la demande, avec le squelette des listes. */
export function LazyRoute({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="route-loading" aria-busy="true">
          <div className="skel-bar" />
          {[0, 1, 2].map((i) => (
            <div key={i} className="skel-row" />
          ))}
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
